<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="roleEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} Role</h2>
        <mat-dialog-content *ngIf="Copy">
            <mat-tab-group>
                <mat-tab label="General">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>Title</mat-label>
                                <textarea matInput name="id" [(ngModel)]="Copy.Id"
                                          required></textarea>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>Description</mat-label>
                                <textarea matInput name="description" [(ngModel)]="Copy.Description"
                                          required></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="API">
                    <div class="row">
                        <table class="mat-mdc-table">
                            <tr>
                                <th>API Model Name</th>
                                <th>Toegangstype</th>
                                <th>Description</th>
                                <th class="text-right">
                                    <button type="button" mat-icon-button
                                            (click)="aAPIEditor.edit({PrincipalId: 'API', RoleId: Copy.Id})">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </th>
                            </tr>
                            <tr *ngFor="let acl of Copy.API_ACLs">
                                <td>{{acl.PrincipalType}}</td>
                                <td>{{acl.AccessType}}</td>
                                <td>{{acl.Description}}</td>
                                <td class="text-right">
                                    <button type="button" mat-icon-button (click)="aAPIEditor.edit(acl)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button appConfirmDialog
                                            (confirm)="aAPIEditor.remove(acl)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab label="GUI">
                    <div class="row">
                        <table class="mat-mdc-table">
                            <tr>
                                <th>GUI permission name</th>
                                <th>Toegangstype</th>
                                <th>Description</th>
                                <th class="text-right">
                                    <button type="button" mat-icon-button
                                            (click)="aGUIEditor.edit({PrincipalId: 'GUI', RoleId: Copy.Id})">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </th>
                            </tr>
                            <tr *ngFor="let acl of Copy.GUI_ACLs">
                                <td>{{acl.PrincipalType}}</td>
                                <td>{{acl.AccessType}}</td>
                                <td>{{acl.Description}}</td>
                                <td class="text-right">
                                    <button type="button" mat-icon-button (click)="aGUIEditor.edit(acl)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button appConfirmDialog
                                            (confirm)="aGUIEditor.remove(acl)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>

<app-acl-editor #aAPIEditor [List]="Copy.API_ACLs" (ListChange)="Copy.API_ACLs = $event"></app-acl-editor>
<app-acl-editor #aGUIEditor [List]="Copy.GUI_ACLs" (ListChange)="Copy.GUI_ACLs = $event"></app-acl-editor>
